import { Container, Row } from 'react-bootstrap';
import SideBar from '../Menu';

export const PublicRoute = ({ children }) => {
  return (
    <Row>
      <SideBar />
      <Container className="text-center mt-2 mb-2 min-h-100">{children}</Container>
    </Row>
  );
};
